import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { QuoteBand } from "@/components/Section";

export default function Services() {
  const { t } = useLang();
  const s = t.servicesPage;
  useSeo("services");
  return (
    <>
      <PageHero eyebrow={s.eyebrow} title={s.title} intro={s.intro} img="/img/customs.jpg" testId="services-hero" />
      <section className="bg-[#F7F9FB] py-24 lg:py-32" data-testid="services-page">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12"><ServicesGrid /></div>
      </section>
      <QuoteBand testId="services-quote-band" />
    </>
  );
}
